/* eslint-disable max-params */
/* eslint-disable complexity */
/**
 * im服务的消息业务
 */
import ImService from "@/server/ImService";
import { removeChatSession } from "@/server/im/SessionService";
import ChatState from "@/types/chat/State";
import {
  ChatMessage,
  ChatMessagePlusEmitBody,
  ChatMessageRespBody,
  ChatMessageType,
  Employee,
  MessageEmitCategory,
  MessageStatus,
  Session,
  UID
} from "@/types/chat";
import {
  addContactsSuccess,
  checkSysMessage,
  employeeToUid,
  getGroupNotifyMessage,
  getNoticeNotifyMessage,
  getSingleNotifyMessage,
  isAnnounceMessage,
  isEqualEmployee,
  isEqualUid,
  isGroupMemberDeleteMessage,
  isGroupBotStopMessage,
  isMultiSyncMessage,
  isShieldSession,
  isSuperviseMessage,
  isSysMessage,
  setMessageGroupId,
  messageCompare,
  isTaskMessage,
  isJAVSDKMeetingMessage,
  processMessageStatus,
  isCalendarMessage,
  isSysNoticeMessage,
  isQuillMsg,
  buildTemplate2MessageBody,
  isGroupAIMerge,
  isQuickReplyText,
  isGroupMemberInMessage,
  isJoyWorkMessage
} from "@/utils/chat/message";
import { FocusSDK, isFocusEnv } from "@/utils";
import Bus from "@/utils/bus";
import findLastIndex from "lodash/findLastIndex";
import lodashPick from "lodash/pick";
import log from "@/utils/logger";
import { isAIChatNoticeSessionId, isAIChatSession, isAINoticeSession } from "@/utils/chat/session";
import CHAT_NOTICE from "@/contant/chat";
import { handleMeetingMessage } from "@/baseComponents/Meeting/utils";
import {
  isGroupCleanMessage,
  processMessageMerge,
  processCommMessageMerge,
  isHitKeywordMessageV2,
  isSkipAIMerge
} from "@jd/jdee.im.sdk/lib/es/utils/utils";
import { WinType } from "@/pagesv2/NewWindow/ReminderWindow";
import { GroupMessagePart } from "@/types/work";
import { isUnifiedToDoListCard, KEY_UNIFIED_TODO_PIN } from "@/services/AINoticeCardService";

const logger = log.getLogger("ImService");

interface GetMergedResp {
  toMerge: ChatMessage[];
  needMerge: boolean;
}

function sendMultiSyncMessage(message: any) {
  const { appName } = message;
  Bus.emit(`chat_message_multiSync_event:${appName}`, message);
}

function sendSuperviseMessage(message: any) {
  if (isFocusEnv()) {
    // console.log("催办消息--》〉", message);
    // 发送消息到桌面端
    const { infox } = message;
    if (infox?.superviseId && infox?.sendType !== "SMS" && infox?.sendType !== "COMMENT") {
      const superviseId = message.infox.superviseId;
      const mid = message.mid;
      const sessionId = message.requestData?.sessionId || message.sessionId;
      Bus.emit("reminder:pop-up-notification", {
        cid: `supervise_${superviseId}`,
        wintype: WinType.SUPERVISE,
        superviseId,
        mid,
        sessionId,
        deepLink: infox.deepLink
      });
    }
  }
}

export function sendTaskMessage(message: any) {
  if (isFocusEnv() && message.infox?.msgType === "1") {
    const { extend, infox } = message;
    const deepLink = new URL(infox.deepLink);
    const { msgTitle, isExceed, endTime, taskName, msgType, businessId } = infox;
    // 标题可能有特殊字符
    infox.taskName = encodeURIComponent(infox.taskName || "");
    const params = JSON.parse(deepLink.searchParams.get("mparam") || "");
    const { taskId, mid, sessionId } = params;
    Bus.emit("reminder:pop-up-notification", {
      cid: `task_${taskId}_${businessId}`,
      wintype: WinType.TASK,
      taskId,
      msgType,
      mid,
      sessionId,
      msgTitle,
      endTime,
      taskName,
      deepLink: infox.deepLink
    });
  }
}

function sendCalendarMessage(message: any) {
  if (isFocusEnv() && message?.extend?.type === "4") {
    // console.log("sendCalendarMessage--->>>", message);
    const { extend, infox, sessionId, mid, title } = message;
    const { beginTime, endTime } = extend;
    const deepLink = new URL(infox.deepLink);
    const params = JSON.parse(
      deepLink?.searchParams?.get("mparam") || `{"scheduleId": "${extend?.scheduleId}"}`
    );
    Bus.emit("reminder:pop-up-notification", {
      cid: `calendar_${params.scheduleId}`,
      wintype: WinType.CALENDAR,
      sessionId,
      mid,
      title,
      scheduleTitle: extend?.scheduleTitle,
      timeDesc: extend?.timeDesc,
      beginTime: beginTime,
      endTime: endTime,
      deepLink: infox.deepLink
    });
  }
}

function sendSysNoticeMessage(message: any) {
  if (isFocusEnv() && message?.extend?.globalAlert === "1") {
    // console.log("sendSysNoticeMessage--->>>", message);
    const { extend, infox, title } = message;
    Bus.emit("reminder:pop-up-notification", {
      cid: `sysnotice_${infox?.noticeId}`,
      wintype: WinType.SYSNOTICE,
      title,
      fields: JSON.stringify(extend?.fields),
      deepLink: extend?.url
    });
  }
}
function handleJoyworkMessage(message: any) {
  switch (message.data?.part) {
    case GroupMessagePart.TASK_GROUP_ADD_USER:
    case GroupMessagePart.TASK_GROUP_REMOVE_USER:
    case GroupMessagePart.TASK_GROUP_CREATE:
    case GroupMessagePart.TASK_GROUP_REMOVE:
      Bus.emit("joywork:refresh-group", message.data);
      break;
    default:
      break;
  }
}

function saveJoyMeetingMessage(message: any) {
  const imService = ImService.getInstance();
  const chatManager = imService.getChatManager();
  if (!chatManager) {
    return;
  }
  if (message.ext) {
    const { sessionState, meetingNumber } = message.ext;
    if (sessionState === 0) {
      chatManager.method.message
        .updateLocal(message.sessionId, message.mid, message, true)
        .then(() => {
          logger.debug("save joymeeting messag ok");
          chatManager.method.session.isNew({ sessionId: message.sessionId }).then(({ session }) => {
            if (session) {
              chatManager.method.message
                .business(session.sessionId, session.lastReadMid)
                .then((params) => {
                  session.unreadCount = params.unreadCount;
                  Bus.emit("chat:session-update", session);
                });
            }
          });
        })
        .catch((e) => {
          logger.error("failed to save joymeeting message", e);
        });
    } else if (sessionState === 1) {
      imService
        .findMeetingMessage(meetingNumber, message.sessionId, message.mid)
        .then((msg: any) => {
          logger.debug("findMeetingMessage result", { message, msg });
          chatManager.method.message
            .updateLocal(msg.sessionId, msg.mid, message)
            .then(() => {
              logger.debug("update meeting message ok");
              Bus.emit("chat:message-change", message);
            })
            .catch((e) => {
              logger.error("failed to update meeting message when close meeting", e);
            });
        })
        .catch((e: any) => {
          logger.error("failed to findMeetingMessage", e);
        });
      return { changed: false };
    } else {
      return { changed: false };
    }
  }
}

// eslint-disable-next-line complexity
function forwardMessage(
  message: ChatMessage & ChatMessageRespBody & any,
  currentEmployee: Employee,
  selectedSession: Session
): boolean {
  let flag = false;
  if (isAIChatSession(selectedSession)) {
    if (isJAVSDKMeetingMessage(message)) {
      handleMeetingMessage(message, currentEmployee);
      flag = true;
    }
    return flag;
  }
  if (isJAVSDKMeetingMessage(message)) {
    handleMeetingMessage(message, currentEmployee);
    flag = true;
  } else if (isSuperviseMessage(message) && !message.isRead) {
    // 督办消息
    sendSuperviseMessage(message);
    Bus.emit("supervise/update");
    flag = true;
  } else if (isTaskMessage(message) && !message.isRead) {
    sendTaskMessage(message);
    flag = true;
  } else if (isCalendarMessage(message) && !message.isRead) {
    sendCalendarMessage(message);
    flag = false;
  } else if (isSysNoticeMessage(message) && !message.isRead) {
    sendSysNoticeMessage(message);
    flag = true;
  } else if (isAnnounceMessage(message)) {
    if (!message.isRead) {
      // 公告消息
      Bus.emit("announce:openModal", message);
    }
    flag = true;
  } else if (isMultiSyncMessage(message) && !isGroupCleanMessage(message)) {
    // 10000 为多端同步消息 直接传递
    sendMultiSyncMessage(message);
    flag = true;
  } else if (addContactsSuccess(message)) {
    // 添加好友成功
    Bus.emit("address:add_friend_success");
    flag = false;
  }
  /* else if (isMergeForwardMessage(message, selectedSession)) {
        // 是合并转发的消息
        flag = true;
    } */
  // AI助手需触发更新
  if (isAINoticeSession(selectedSession) && message?.from?.pin !== CHAT_NOTICE.SYS_PIN) {
    flag = false;
  }
  if (isJoyWorkMessage(message)) {
    handleJoyworkMessage(message);
  }
  if (isUnifiedToDoListCard(message)) {
    Bus.emit(`chat_message_multiSync_event:${KEY_UNIFIED_TODO_PIN}`, message);
  }
  return flag;
}

/**
 * 桌面端消息提醒
 * @param allSessionList
 * @param message
 * @param currentEmployee
 */
function sendMessageNotify(
  allSessionList: Session[],
  message: ChatMessage,
  currentEmployee: Employee
): any {
  if (message.category !== MessageEmitCategory.CHAT_MESSAGE) {
    return;
  }
  if (isEqualEmployee(message.sender, currentEmployee)) {
    return;
  }
  if (isSysMessage(message)) {
    return;
  }
  // 取消 sys 类型的消息提醒
  const session = allSessionList.find((item) => item.sessionId === message.sessionId);
  if (!session || isShieldSession(session)) {
    // 取消消息提醒不发送消息通知
    return;
  }

  if (session.isNotice) {
    // 新消息提醒 通知 发送事件
    Bus.emit("chat_message_new_message", {
      message: getNoticeNotifyMessage(session, message, currentEmployee)
    });
  } else if (session.isSingle) {
    // 新消息提醒 单聊 发送事件
    Bus.emit("chat_message_new_message", {
      message: getSingleNotifyMessage(session, message, currentEmployee)
    });
  } else if (session.isGroup) {
    // 新消息提醒 群聊 发送事件
    Bus.emit("chat_message_new_message", {
      message: getGroupNotifyMessage(session, message, currentEmployee)
    });
  }
}

/**
 * 获取要聚合的消息
 * @param session
 * @param messages
 * @param message
 * @returns
 */
export function getToMergeMessage(
  session: Session | undefined,
  messages: ChatMessage[],
  message: ChatMessage & ChatMessagePlusEmitBody
): GetMergedResp {
  if (message.category !== MessageEmitCategory.CHAT_MESSAGE) {
    return {
      toMerge: [],
      needMerge: false
    };
  }
  if (message.type !== ChatMessageType.TEXT) {
    return {
      toMerge: [],
      needMerge: false
    };
  }
  if (
    message.type === ChatMessageType.TEXT &&
    ((message as any).nativeId === "share_link" ||
      isQuillMsg(message?.quillJson) ||
      message.subType === ChatMessageType.QUICK_REPLY)
  ) {
    return {
      toMerge: [],
      needMerge: false
    };
  }
  if (message.fuuid || message.reply) {
    return {
      toMerge: [],
      needMerge: false
    };
  }
  if (
    message.type === ChatMessageType.TEXT &&
    (message as any).meetingCard &&
    (message as any).meetingCard.meetingId
  ) {
    return {
      toMerge: [],
      needMerge: false
    };
  }

  if (message.statusType === MessageStatus.FAILED) {
    const lastMessages = messages.slice(-3);
    const needMerge = getNeedToMerge(messages, message);
    return {
      toMerge: lastMessages,
      needMerge
    };
  }

  if (!session) {
    return {
      toMerge: [],
      needMerge: false
    };
  }
  if (!session.isGroup && !session.isMeeting) {
    return {
      toMerge: [],
      needMerge: false
    };
  }
  const lastMessages = messages.slice(-3);
  const len = lastMessages.length;
  for (let i = len; i > 0; i--) {
    if (
      lastMessages[i - 1].type !== ChatMessageType.TEXT ||
      (lastMessages[i - 1] as any)?.meetingCard?.meetingId ||
      lastMessages[i - 1].reply ||
      lastMessages[i - 1].revoke > 0
    ) {
      const toMerge = lastMessages.splice(i);
      const needMerge = getNeedToMerge(toMerge, message);
      return {
        toMerge,
        needMerge
      };
    }
  }
  const needMerge = getNeedToMerge(lastMessages, message);
  return {
    toMerge: lastMessages,
    needMerge
  };
}

function getNeedToMerge(messages: ChatMessage[], message: ChatMessage): boolean {
  const last = messages.slice(-1)[0];
  if (
    message.type === ChatMessageType.TEXT &&
    (message as any).meetingCard &&
    (message as any).meetingCard.meetingId
  ) {
    return false;
  }
  if ((last as ChatMessagePlusEmitBody)?.plusList && last.content === message.content) {
    return true;
  }

  const lastest = messages.slice(-2);
  return (
    lastest.length >= 2 &&
    lastest.filter((m) => m.content === message.content).length === lastest.length
  );
}
export function dealMessageMerged(
  session: Session | undefined,
  messages: ChatMessage[],
  message?: ChatMessage
): ChatMessage[] {
  const imService = ImService.getInstance();
  if (!imService || !session || !messages.length) {
    return messages;
  }
  const _messages = message || messages[messages.length - 1];
  const { needMerge } = getToMergeMessage(session, messages, _messages);
  if (needMerge) {
    const merged = processMessageMerge(messages)?.mergedMessages;
    return merged;
  }
  return messages;
}

// 智能聚合
export async function dealCommMessageMerged(
  session: Session | undefined,
  messages: ChatMessage[],
  opts: {
    keywords: string[];
    duration: number;
  }
): Promise<ChatMessage[]> {
  const imService = ImService.getInstance();
  if (!imService || !session || !messages.length) {
    return messages;
  }
  const merged = ((await processCommMessageMerge(messages, opts)) as any)?.mergedMessages;
  return merged;
}

/**
 * 获取session
 * @param allSessionList
 * @param message
 * @returns
 */
function getSession(allSessionList: Session[], message: ChatMessage): Session | undefined {
  return allSessionList.find((item) => item.sessionId === message.sessionId);
}

function getSessionById(allSessionList: Session[], sessionId: string): Session | undefined {
  return allSessionList.find((item) => item.sessionId === sessionId);
}

/**
 * 快速发送消息时，因为发消息触发的此事件可能晚于当前消息的dongRead执行
 * @param sessionMessage
 * @param mergeMessage
 * @returns
 */
function mergeData(sessionMessage: any, mergeMessage: any) {
  let { readUids } = sessionMessage;
  let { readUids: newReadUids } = mergeMessage;
  let rtnMergeData = {};
  if (readUids?.length && !newReadUids?.length) {
    rtnMergeData = {
      readUids
    };
  }

  return rtnMergeData;
}

/**
 * 处理一条新消息
 * 接收的消息 只有当前选择会话的消息 其它会话的消息不用关心
 * @param chatState
 * @param message
 */
// eslint-disable-next-line complexity
export async function dealSessionNewMessage(
  chatState: ChatState,
  message: ChatMessage & ChatMessageRespBody & any,
  options: {
    keywords: string[],
    duration: number,
    aiMergeLocal: boolean,
    aiMergeRule: any
  }
): Promise<any> {
  const t = new Date().getTime();
  const {
    sessionMessageMap,
    allSessionList,
    selectedSession,
    currentEmployee,
    llmSetting
  } = chatState;
  const currentUID = employeeToUid(currentEmployee);
  if (!message) {
    return { changed: false };
  }
  const forward = forwardMessage(message, currentEmployee, selectedSession);
  if (forward) {
    return { changed: false };
  }
  // tj: 处理空图片消息
  if (message?.type === ChatMessageType.IMAGE && !message?.url) {
    return { changed: false };
  }
  const session = getSession(allSessionList, message);
  // 移除成员且成员是自已
  if (message && message.category === MessageEmitCategory.SYSTEM) {
    if (isGroupMemberDeleteMessage(message) && isEqualUid(currentUID, message.members[0] as UID)) {
      // 移除会话
      await removeChatSession(message.sessionId);
      return { changed: false };
    } else if (
      isGroupMemberInMessage(message) ||
      isGroupMemberDeleteMessage(message) ||
      isGroupBotStopMessage(message)
    ) {
      Bus.emit("chat:load-group-robots", session);
    }
  }
  const imService = ImService.getInstance();
  const sessionId = message.sessionId;
  const isAIChat = await isAIChatNoticeSessionId(sessionId);
  // if (message.sessionId !== selectedSession.sessionId) {
  //     // 如果不是当前打开的聊天会话
  //     return { changed: false };
  // }
  if (!isAIChat && message && message.category === MessageEmitCategory.SYSTEM) {
    // 系统通知类消息，需要检查是否有展示的权限
    if (!session) {
      return { changed: false };
    }
    const checkResult = checkSysMessage({ message, session }); // 检查消息是否要展示
    if (!checkResult) {
      return { changed: false };
    }
  }
  // 有当前会话存在 并且新消息是属于当前会话的 将新消息插入到会话消息映射结构中
  let chatMessages = (sessionMessageMap || {})[sessionId] || [];
  // chatMessages = chatMessages.sort(messageCompare);
  // console.log('chatMessages111', chatMessages);
  const index = findLastIndex(chatMessages, (item) => item.id === message.id);
  let newMessage = { ...message };
  if (index > -1) {
    // ai答题消息处理
    if (isAIChat) {
      if ((chatMessages[index] as any)?.flag === "end") {
        return { changed: false };
      } else if (message.flag === "end" && (message?.intentionType?.length || 0) > 1) {
        const { settings = [] } = llmSetting;
        // 处理意图识别
        const cardInfo: any[] = [];
        if (!message?.content) {
          message.content = "您好，请告诉我您想要我帮您做什么？";
        }
        message?.intentionType.forEach((i: string) => {
          const item = settings.find((s: any) => s.knowledgeBaseId === i);
          if (item) {
            cardInfo.push(item);
          }
        });
        message.template = {
          nativeId: "share_hint_multi"
        };
        message.data = cardInfo;
        message.type = ChatMessageType.TEMPLATE2;
      }
    }
    let mergeMessage = message;
    if (message.type === "revoke_message") {
      mergeMessage = lodashPick(message, ["id", "revoke", "revokeTime", "revoker"]);
      chatMessages.forEach((item, idx) => {
        if (item.replyMsgs && item.replyMsgs.length > 0) {
          const replyMsg = item.replyMsgs[0] as ChatMessage;
          if (replyMsg?.id === mergeMessage.id) {
            chatMessages[idx] = {
              ...chatMessages[idx],
              replyMsgs: [{ ...replyMsg, ...mergeMessage }]
            };
          }
        }
      });
    }
    if (message.type === "message_tag") {
      mergeMessage = lodashPick(message, ["id", "tag"]);
      chatMessages.forEach((item, idx) => {
        if (item.replyMsgs && item.replyMsgs.length > 0) {
          const replyMsg = item.replyMsgs[0] as ChatMessage;
          if (replyMsg?.id === mergeMessage.id) {
            chatMessages[idx] = {
              ...chatMessages[idx],
              replyMsgs: [{ ...replyMsg, ...mergeMessage, type: "text" }]
            };
          }
        }
      });
    }
    let mergeReadUids = mergeData(chatMessages[index], mergeMessage);
    newMessage = {
      ...chatMessages[index],
      ...mergeMessage,
      ...mergeReadUids
      // timestamp: chatMessages[index].timestamp,
    };
    chatMessages[index] = newMessage;
    if (isGroupCleanMessage(message)) {
      chatMessages = chatMessages.filter((msg) => {
        const { beginTime, endTime } = message;
        return msg.timestamp > endTime || msg.timestamp < beginTime || msg.id === message.id;
      });
    }
    // tj: 增加消息排序
    if (
      sessionId === selectedSession.sessionId &&
      (selectedSession.isGroup || selectedSession.isMeeting)
    ) {
      // chatMessages = uniqMergedMessage(chatMessages);
      if (
        isGroupAIMerge(selectedSession) &&
        options.aiMergeLocal &&
        isHitKeywordMessageV2(message, options.aiMergeRule) &&
        isFocusEnv() &&
        message.statusType === MessageStatus.SUCCESS
      ) {
        // 处理
        chatMessages = await dealCommMessageMerged(session, chatMessages, options);
      } else if (!isSkipAIMerge(message)) {
        // 只聚合最后3条
        chatMessages = dealMessageMerged(session, chatMessages, message);
      }
      chatMessages = chatMessages.sort(messageCompare);
    } else {
      if (session) {
        chatMessages = processMessageStatus(session, chatMessages, currentEmployee);
      }
    }
    sessionMessageMap[sessionId] = [...chatMessages];
    return { sessionMessageMap, changed: true, newMessage };
  } else {
    if (message.type === "revoke_message") {
      chatMessages = chatMessages.map((item: any) => {
        if (!item.plusList) {
          return item;
        }
        const i = item.plusList.findIndex((u: any) => u.messageId === message.mid);
        if (i !== -1) {
          item.plusList[i] = { ...item.plusList[i], statusType: MessageStatus.REVOKE };
          item.revokeTime = message.revokeTime;
          if (item.statusType !== MessageStatus.TEMP) {
            // 更新本地
            imService
              .updateMergedMessage(message.sessionId, item.mid, {
                ...item,
                plusList: item.plusList,
                revokeTime: message.revokeTime
              })
              .then();
          }
        }
        return item;
      });
      sessionMessageMap[sessionId] = chatMessages;
      return { sessionMessageMap, changed: true };
    }
    if (message.type === "message_tag") {
      chatMessages = chatMessages.map((item: any) => {
        if (!item.plusList) {
          return item;
        }
        const i = item.plusList.findIndex((u: any) => u.messageId === message.mid);
        if (i !== -1) {
          item.plusList[i] = { ...item.plusList[i] };
          if (item.statusType !== MessageStatus.TEMP) {
            // 更新本地
            imService
              .updateMergedMessage(message.sessionId, item.mid, {
                ...item,
                plusList: item.plusList
              })
              .then();
          }
        }
        return item;
      });
      sessionMessageMap[sessionId] = chatMessages;
      return { sessionMessageMap, changed: true };
    }
    if (message.fuuid) {
      return { sessionMessageMap, changed: true };
    }
    if (isGroupCleanMessage(message)) {
      chatMessages = chatMessages.filter((msg) => {
        const { beginTime, endTime } = message;
        return msg.timestamp > endTime || msg.timestamp < beginTime;
      });
    }
    let messages = chatMessages.concat([message]).sort(messageCompare);
    if (
      sessionId === selectedSession.sessionId &&
      (selectedSession.isGroup || selectedSession.isMeeting)
    ) {
      // chatMessages = uniqMergedMessage(messages);
      if (
        isGroupAIMerge(selectedSession) &&
        options.aiMergeLocal &&
        isHitKeywordMessageV2(message, options.aiMergeRule) &&
        isFocusEnv() &&
        message.statusType === MessageStatus.SUCCESS
      ) {
        // 处理智能聚合
        messages = await dealCommMessageMerged(session, messages, options);
      } else {
        // 只聚合最后3条
        messages = dealMessageMerged(session, messages, message);
      }
      messages = messages.sort(messageCompare);
    }
    const lastMessage = messages[messages.length - 1] || null;
    const prevMessage = messages[messages.length - 2] || null;
    if (lastMessage) {
      setMessageGroupId(lastMessage, prevMessage);
    }
    // 距现在最近的消息在消息数组后面位置
    sessionMessageMap[sessionId] = messages;
    // 新消息未读兼容处理;
    if (session) {
      messages = processMessageStatus(session, messages, currentEmployee);
    }
    // 消息提醒
    sendMessageNotify(allSessionList, message, currentEmployee);
    FocusSDK.sendTrackLog({
      type: "RECMSG",
      data: {
        proc_et: new Date().getTime() - t,
        end_ts: new Date().getTime(),
        id: message.id
      }
    });
    return { sessionMessageMap, changed: true, newMessage: messages };
  }
}

/**
 * 批量处理消息
 * @param chatState
 * @param messages
 * @returns
 */
// eslint-disable-next-line complexity
export async function dealSessionBatchMessage(
  chatState: ChatState,
  messages: ChatMessage & ChatMessageRespBody & any[],
  sessionId: string,
  options: {
    keywords: string[],
    duration: number,
    aiMergeLocal: boolean,
    aiMergeRule: any
  }
): Promise<any> {
  const t = new Date().getTime();
  const _messages = messages.sort(messageCompare);
  const { sessionMessageMap, allSessionList, currentEmployee, selectedSession } = chatState;
  const currentUID = employeeToUid(currentEmployee);
  const imService = ImService.getInstance();
  let chatMessages = (sessionMessageMap || {})[sessionId] || [];
  let changed = false;
  const session = getSessionById(allSessionList, sessionId);
  if (!session) {
    return {
      sessionMessageMap,
      changed
    };
  }
  if (isGroupAIMerge(session) && session.sessionId !== selectedSession.sessionId) {
    return {
      sessionMessageMap,
      changed
    };
  }
  for (const message of _messages) {
    if (!message || (isGroupAIMerge(session) && message.skipMerge)) {
      continue;
    }
    const forward = forwardMessage(message, currentEmployee, session);
    if (forward) {
      continue;
    }
    // 过滤AI助手不展示的卡片消息
    if (isAINoticeSession(session) && message?.from?.pin === CHAT_NOTICE.SYS_PIN) {
      continue;
    } // tj: 处理空图片消息
    if (message?.type === ChatMessageType.IMAGE && !message?.url) {
      continue;
    } // 移除成员且成员是自已
    if (message && message.category === MessageEmitCategory.SYSTEM) {
      if (
        isGroupMemberDeleteMessage(message) &&
        isEqualUid(currentUID, message.members[0] as UID)
      ) {
        // 移除会话
        removeChatSession(message.sessionId).then();
        continue;
      }
    }
    if (message && message.category === MessageEmitCategory.SYSTEM) {
      // 系统通知类消息，需要检查是否有展示的权限
      const checkResult = checkSysMessage({
        message,
        session
      }); // 检查消息是否要展示
      if (!checkResult) {
        continue;
      }
    }
    changed = true;
    // chatMessages = chatMessages.sort(messageCompare);
    const index = findLastIndex(chatMessages, (item) => item.id === message.id);
    if (index > -1) {
      let mergeMessage = message;
      if (message.type === "revoke_message") {
        mergeMessage = lodashPick(message, ["id", "revoke", "revokeTime", "revoker"]);
        chatMessages.forEach((item, idx) => {
          if (item.replyMsgs && item.replyMsgs.length > 0) {
            const replyMsg = item.replyMsgs[0] as ChatMessage;
            if (replyMsg?.id === mergeMessage.id) {
              chatMessages[idx] = {
                ...chatMessages[idx],
                replyMsgs: [{ ...replyMsg, ...mergeMessage }]
              };
            }
          }
        });
      }
      chatMessages[index] = {
        ...chatMessages[index],
        ...mergeMessage
        // timestamp: chatMessages[index].timestamp,
      };
      // tj: 增加消息排序
      chatMessages = chatMessages.sort(messageCompare);
      if (session.isGroup && !isGroupAIMerge(session)) {
        // chatMessages = uniqMergedMessage(chatMessages);
        // 只聚合最后3条
        chatMessages = dealMessageMerged(session, chatMessages, message);
        chatMessages = chatMessages.sort(messageCompare);
      }
    } else {
      if (message.type === "revoke_message") {
        chatMessages = chatMessages.map((item: any) => {
          if (!item.plusList) {
            return item;
          }
          const i = item.plusList.findIndex((user: any) => user.messageId === message.mid);
          if (i !== -1) {
            item.plusList[i] = {
              ...item.plusList[i],
              statusType: MessageStatus.REVOKE
            };
            if (item.statusType !== MessageStatus.TEMP) {
              // 更新本地
              imService
                .updateMergedMessage(message.sessionId, item.mid, {
                  ...item,
                  plusList: item.plusList
                })
                .then();
            }
          }
          return item;
        });
        continue;
      }
      if (message.fuuid) {
        continue;
      }
      let messages = chatMessages.concat([message]).sort(messageCompare);
      if (session.isGroup) {
        // messages = uniqMergedMessage(messages);
        // 只聚合最后3条
        if (
          isGroupAIMerge(selectedSession) &&
          options.aiMergeLocal &&
          isHitKeywordMessageV2(message, options.aiMergeRule) &&
          isFocusEnv() &&
          message.statusType === MessageStatus.SUCCESS
        ) {
          // 处理
          messages = await dealCommMessageMerged(session, messages, options);
        } else {
          messages = dealMessageMerged(session, messages, message);
        }
        messages = messages.sort(messageCompare);
      }
      const lastMessage = messages[messages.length - 1] || null;
      const prevMessage = messages[messages.length - 2] || null;
      // 距现在最近的消息在消息数组后面位置
      setMessageGroupId(lastMessage, prevMessage);
      // 新消息未读兼容处理
      processMessageStatus(session, messages, currentEmployee);
      chatMessages = messages;
      // 消息提醒
      sendMessageNotify(allSessionList, message, currentEmployee);
      FocusSDK.sendTrackLog({
        type: "RECMSG",
        data: {
          proc_et: new Date().getTime() - t,
          end_ts: new Date().getTime(),
          id: message.id
        }
      });
    }
  }

  sessionMessageMap[session.sessionId] = chatMessages;
  return { sessionMessageMap, changed };
}
